<div #container class="nc-iridescence-canvas-container"></div>
<div class="nc-content-wrapper">
    <ng-content></ng-content>
</div>